import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LessonState } from '../reducers/lesson.reducer';
import { LESSON_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<LessonState>(LESSON_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: LessonState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: LessonState) => state.loading);
export const selectSaving = createSelector(selectState, (state: LessonState) => state.saving);
export const selectSaved = createSelector(selectState, (state: LessonState) => state.saved);
export const selectError = createSelector(selectState, (state: LessonState) => state.error);
export const selectLesson = createSelector(selectState, (state: LessonState) => state.lesson);
